import React from "react";
function InputError({ apiErrors }) {
    const errors = apiErrors;
    return (React.createElement(React.Fragment, null, errors && React.createElement("span", { className: "error" }, errors)));
}
export default InputError;
